<template>
  <div>
    <b-card class="border-none">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>
        <!-- <AddPageDetail /> -->
        <template slot="footer">
          <base-button type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>

      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">Brochure</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <base-button outline class="px-6 py-1 mx-1" type="primary">
            <!-- v-if="borach.length == 0" -->
            <span class="btn-inner--text flex" @click="isShowAddCoach"
              ><feather-icon icon="PlusIcon" class="mr-2 cust-HW"></feather-icon
              >Add</span
            >
          </base-button>
        </div>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
          v-model="search"
          @keyup="searchData"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="borach"
        border
      >
        <!-- <el-table-column label="Sr no." prop="srno" min-width="130px" sortable>
        </el-table-column> @click="handleEdit(scope.$index, scope.row)" -->

        <el-table-column label="Name" min-width="150px" prop="name" sortable>
          <template v-slot="{ row }">
            <span class="text-black">{{ row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Edited By"
          prop="editedby"
          min-width="130px"
          sortable
        >
          <template v-slot="{ row }">
            <p
              class="font-semibold text-left name mb-0 text-sm"
              v-if="row.isEdited"
            >
              {{
                row.editedBy.at(-1)._user.firstname +
                  " " +
                  row.editedBy.at(-1)._user.lastname || " "
              }}
            </p>
          </template>
        </el-table-column>

        <el-table-column property="action" label="Action" width="">
          <template v-slot="{ row }">
            <div class="flex items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5"
                class="cursor-pointer text-primary"
                @click="handleEdit(row)"
              />
              <feather-icon
                svgClasses="w-5 h-5"
                class="ml-2 cursor-pointer text-danger"
                icon="Trash2Icon"
                @click="handleDelete(row)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total="total_row"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
// import "../../scss/Index.scss";
import Data from "./components/Data";
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      Data,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      approve: false,
      search: "",
      total_row: 1,
      perPage: 5,
    };
  },
  methods: {
    async handleEdit(row) {
      this.$store.commit("coach/BROACH_DETAILS_ALL", row);
      this.$router.push({ name: "edit-coach" });
    },
    async handleDelete(row) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(row);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(row) {
      let payload = {
        _id: row._id,
      };
      let loader = this.$loading();
      try {
        const deletedata = await this.$store.dispatch(
          "coach/DeleteBrochure",
          payload
        );
        loader.close();
        if (deletedata.code == 200) {
          this.$swal.fire({
            text: "Brochure successfully removed",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          await this.$store.dispatch("coach/GetBrochure");
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    isShowAddCoach() {
      this.$router.push({ name: "add-coach" });
    },
    add() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    async searchData() {
      let payload = {
        search: this.search,
      };
      await this.$store.dispatch("coach/GetBrochure", payload);
    },
  },
  async created() {
    try {
      await this.$store.dispatch("coach/GetBrochure");
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    ...mapState("coach", {
      borach: "borach",
    }),
  },
};
</script>
